var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFAddress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#D263E4",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1066 16.9336C13.9898 17.0629 13.8667 17.1943 13.7376 17.3256C14.9491 17.4882 15.7791 17.8239 15.7791 18.2097C15.7791 18.756 14.1192 19.1981 12.0693 19.1981C10.0195 19.1981 8.35951 18.756 8.35951 18.2097C8.35951 17.8365 9.13524 17.511 10.28 17.3444C10.1507 17.215 10.0298 17.0857 9.913 16.9566C8.29072 17.2652 7.17285 17.9096 7.17285 18.6561C7.17285 19.7008 9.36446 20.5496 12.0692 20.5496C14.7717 20.5496 16.9655 19.7008 16.9655 18.6561C16.9677 17.8907 15.7936 17.2318 14.1066 16.9336Z",
    fill: "#D263E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3946 8.84417C17.3946 5.86417 14.9799 3.44922 12 3.44922C9.02024 3.44922 6.60547 5.86399 6.60547 8.84417C6.60547 11.338 10.3893 16.4426 11.619 18.0358C11.812 18.2857 12.1881 18.2857 12.3811 18.0357C13.6108 16.4426 17.3946 11.3378 17.3946 8.84417ZM9.82501 8.84417C9.82501 7.64297 10.7988 6.66928 11.9979 6.66928C13.1991 6.66928 14.1728 7.64312 14.1728 8.84417C14.1728 10.0454 13.1989 11.017 11.9979 11.017C10.7987 11.017 9.82501 10.0452 9.82501 8.84417Z",
    fill: "#D263E4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFAddress);
export default __webpack_public_path__ + "static/media/fAddress.9a837c1aa8ad29b28b89e64f78204f9b.svg";
export { ForwardRef as ReactComponent };